import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPageContent } from "../../utils";
import {
  selectPersonDetailData,
  selectPersonDetailStatus,
  selectPersonDetailError,
  initializeAsync,
} from "./personDetailSlice";
import {
  CssBaseline,
  Box,
  Container,
  Divider,
  Button,
  Paper,
} from "@mui/material";
import { PersonName } from "../../components/PersonName";
import { Address } from "../../components/Address";
import { RadioButtons } from "../../components/InputField/RadioButtons";
import Stack from "@mui/material/Stack";
import { Input } from "../../components/Input";

import PlainTextField from "../../components/InputField/PlainTextField";
import { Income } from "../../components/Income";

const PersonDetail = () => {
  const data = useSelector(selectPersonDetailData);
  const status = useSelector(selectPersonDetailStatus);
  const error = useSelector(selectPersonDetailError);
  const dispatch = useDispatch();

  const handleFormData = (values) => {
    if (values) console.log(values);
  };
  // Add Variables

  const options = [
    {
      value: "asap",
      label: "ASAP",
    },
    {
      value: "1month",
      label: "1 month",
    },
    {
      value: "2-3months",
      label: "2-3 months",
    },
    {
      value: "4+months",
      label: "4+ months",
    },
    {
      value: "notsure",
      label: "Not sure yet",
    },
  ];

  const options2 = [
    {
      value: "no",
      label: "No",
      subheading: " I want pathway to pair me with one, if  approved",
      componentOnSelect: "",
    },
    {
      value: "yes",
      label: "Yes",
      subheading: " I am working with a licensed real state agent",
      componentOnSelect: (
        <Box>
          <Input
            autoFocus
            id="agentFirstName"
            type="text"
            label="Agent's first name"
            name="firstName"
            margin="normal"
            isRequired={true}
            fullWidth
            onChange={handleFormData}
          />
          <Input
            id="agentlastName"
            type="text"
            label="Agent's last name"
            name="lastName"
            margin="normal"
            isRequired={true}
            fullWidth
            onChange={handleFormData}
          />

          <Input
            id="brokerage"
            type="number"
            label="Brokerage"
            name="brokerage"
            margin="normal"
            isRequired={false}
            fullWidth
            onChange={handleFormData}
          />

          <Input
            id="agentEmail"
            type="email"
            label="Agent's email"
            name="agentEmail"
            margin="normal"
            isRequired={false}
            fullWidth
            onChange={handleFormData}
          />
          <Input
            id="agentPhoneNumber"
            label="Agent's phone number"
            name="agentPhoneNumber"
            margin="normal"
            type="number"
            isRequired={false}
            fullWidth
            onChange={handleFormData}
          />
          <Divider />
        </Box>
      ),
    },
  ];

  useEffect(() => {
    if (status === "idle") {
      dispatch(initializeAsync());
    }
  }, [status, dispatch]);

  const personNameRef = useRef();
  const moveInDateRef = useRef();
  const agentDetailsRef = useRef();
  const addressCompRef = useRef();
  const annualExpensesRef = useRef();
  const annualIncomeSourceRef = useRef();
  const dobRef = useRef();
  const [showItem, setShowItem] = useState(false);
  let body = (
    <Box
      component="main"
      sx={{
        position: "absolute",
        width: "100%",
        height: "100%",
        backgroundColor: "#ffffff",
      }}
    >
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexGrow: 1,
          minHeight: "100%",
        }}
      >
        <Container maxWidth="sm">
          <CssBaseline />
          <Stack spacing={2}>
            <Paper
              elevation={16}
              sx={{
                backgroundColor: "rgb(255, 255, 255)",
                color: "rgb(18, 24, 40)",
                transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                borderRadius: "8px",
                boxShadow: "rgb(100 116 139 / 12%) 0px 10px 15px",
                backgroundImage: "none",
                overflow: "hidden",
                padding: "32px",
              }}
            >
              <PersonName
                label={"How shall we call you ?"}
                ref={personNameRef}
                onChange={handleFormData}
              />
              <Divider sx={{ mt: 2, mb: 2 }} />

              <Button
                variant="contained"
                onClick={() => personNameRef.current.validateForm()}
              >
                Next
              </Button>
            </Paper>

            <Paper
              elevation={16}
              sx={{
                backgroundColor: "rgb(255, 255, 255)",
                color: "rgb(18, 24, 40)",
                transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                borderRadius: "8px",
                boxShadow: "rgb(100 116 139 / 12%) 0px 10px 15px",
                backgroundImage: "none",
                overflow: "hidden",
                padding: "32px",
              }}
            >
              <Input
                type="radio"
                isRequired={true}
                label={"How soon do you want to move ?"}
                options={options}
                ref={moveInDateRef}
                onChange={handleFormData}
              />
              <Divider sx={{ mt: 2, mb: 2 }} />

              <Button
                variant="contained"
                onClick={() => moveInDateRef.current.validate()}
              >
                Next
              </Button>
            </Paper>

            <Paper
              elevation={16}
              sx={{
                backgroundColor: "rgb(255, 255, 255)",
                color: "rgb(18, 24, 40)",
                transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                borderRadius: "8px",
                boxShadow: "rgb(100 116 139 / 12%) 0px 10px 15px",
                backgroundImage: "none",
                overflow: "hidden",
                padding: "32px",
              }}
            >
              <Input
                type="radio"
                isRequired={true}
                label={"Are you working with a real estate agent?"}
                options={options2}
                ref={agentDetailsRef}
                onChange={handleFormData}
              />
              <Divider sx={{ mt: 2, mb: 2 }} />

              <Button
                variant="contained"
                onClick={() => agentDetailsRef.current.validate()}
              >
                Next
              </Button>
            </Paper>

            <Paper
              elevation={16}
              sx={{
                backgroundColor: "rgb(255, 255, 255)",
                color: "rgb(18, 24, 40)",
                transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                borderRadius: "8px",
                boxShadow: "rgb(100 116 139 / 12%) 0px 10px 15px",
                backgroundImage: "none",
                overflow: "hidden",
                padding: "32px",
              }}
            >
              <Input
                type="slider"
                maxValue={2000}
                label={"Monthly expenses"}
                prefix={"$"}
                postfix={""}
                ref={annualExpensesRef}
                onChange={handleFormData}
              />

              <Divider sx={{ mt: 2, mb: 2 }} />
            </Paper>

            <Paper
              elevation={16}
              sx={{
                backgroundColor: "rgb(255, 255, 255)",
                color: "rgb(18, 24, 40)",
                transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                borderRadius: "8px",
                boxShadow: "rgb(100 116 139 / 12%) 0px 10px 15px",
                backgroundImage: "none",
                overflow: "hidden",
                padding: "32px",
              }}
            >
              <Address
                label={"What is your current address?"}
                ref={addressCompRef}
                onChange={handleFormData}
              />
              <Divider sx={{ mt: 2, mb: 2 }} />
              <Button
                variant="contained"
                onClick={() => addressCompRef.current.validateForm()}
              >
                Next
              </Button>
            </Paper>

            <Paper
              elevation={16}
              sx={{
                backgroundColor: "rgb(255, 255, 255)",
                color: "rgb(18, 24, 40)",
                transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                borderRadius: "8px",
                boxShadow: "rgb(100 116 139 / 12%) 0px 10px 15px",
                backgroundImage: "none",
                overflow: "hidden",
                padding: "32px",
              }}
            >
              <Income ref={annualIncomeSourceRef} onChange={handleFormData} />
              <Divider sx={{ mt: 2, mb: 2 }} />
              <Button
                variant="contained"
                onClick={() => annualIncomeSourceRef.current.validateForm()}
              >
                Next
              </Button>
            </Paper>

            <Paper
              elevation={16}
              sx={{
                backgroundColor: "rgb(255, 255, 255)",
                color: "rgb(18, 24, 40)",
                transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
                borderRadius: "8px",
                boxShadow: "rgb(100 116 139 / 12%) 0px 10px 15px",
                backgroundImage: "none",
                overflow: "hidden",
                padding: "32px",
              }}
            >
            <Box>
              <Input
                ref={dobRef}
                id="dob"
                type="date"
                label={"Date of Birth"}
                placeholder="MM / DD / YYYY"
                onChange={(value) => handleFormData("dob", value)}
              ></Input>
            </Box>
            </Paper>
          </Stack>
        </Container>
      </Box>
    </Box>
  );

  return getPageContent(body, status, error);
};

export { PersonDetail };
